module.exports = __webpack_public_path__ + "media/images/proof_links/flickr-3bed8044d664ce045fc30cb83cee386b.svg";